import { IconBox, IconProps } from '@summer/jst-react-icon';

export const Delete = (props: Omit<IconProps, 'ref'>) => (
  <IconBox {...props}>
    <path d="M56.96 10.88H43.52V3.2H20.48v7.68H7.04v3.84h3.84V60.8h42.24V14.72h3.84v-3.84ZM24.32 7.04h15.36v3.84H24.32V7.04Zm24.96 49.92H14.72V14.72h34.56v42.24Z" />
    <path d="M20.48 20.48h3.84V51.2h-3.84V20.48ZM30.08 20.48h3.84V51.2h-3.84V20.48ZM39.68 20.48h3.84V51.2h-3.84V20.48Z" />
  </IconBox>
);
